import axios from "../../../../api/axios";

import { PostTypeEnum } from "../../enums/post.enum";
import { formatFeedParams } from "../formatters/feedParams.formatter";

export const getFeedPosts = async (limit: number, offset: number, postType?: PostTypeEnum) => {
  try {
    const params = formatFeedParams({ limit, offset, postType });
    const response = await axios.get(`/feed/edge-rank?${params}`);
    return response.data.data;
  } catch (err: any) {
    throw new Error(
      err.response?.data?.message || err.message || "An unknown error occurred while fetching feed posts"
    );
  }
};
